<template>
  <li
    @click="itemClick(item)"
    :style="liStyles"
    @mouseover="activeThis"
    :class="
      (active == index ? 'active' : '') +
        ' ' +
        (index == 1 && active != index ? 'toLeft' : '')
    "
  >
    <a :href="item.url" :style="aStyles">
      <div class="sanjiao" v-show="active == index"><div></div></div>
      <div class="redHengBox" v-if="active !== index">
        <h3 v-html="item.name"></h3>
        <div class="redHeng"></div>
      </div>
      <div v-else class="liBox">
        <div class="redHeng"></div>
        <h2 v-text="item.name"></h2>
        <p v-html="item.description"></p>
      </div>
    </a>
  </li>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    styles: {
      type: Object
    },
    active: {
      default: 0
    },
    index: {
      default: 0
    }
  },
  computed: {
    liStyles() {
      const li = {
        backgroundImage: "url(" + this.item.pic + ")"
      };

      if (this.styles && this.styles.li) Object.assign(li, this.styles.li);

      return li;
    },
    aStyles() {
      return this.styles && this.styles.a ? this.styles.a : {};
    },
    h2Styles() {
      return this.styles && this.styles.h2 ? this.styles.h2 : {};
    },
    pStyles() {
      return this.styles && this.styles.p ? this.styles.p : {};
    }
  },
  methods: {
    itemClick(item) {
      console.log(item);
      this.$parent.getID(item, this.index);
      this.$emit("hoverActive", this.index);
    },
    activeThis() {
      this.$emit("hoverActive", this.index);
    }
  }
};
</script>
<style>
.toLeft {
  background-position: 79% 0 !important;
}

.vue-accordion ul li {
  list-style: none;
  vertical-align: bottom;
  position: relative;
  width: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  transition: all 500ms ease;
  height: 100%;
  /* overflow: hidden; */
  margin-right: 20px;
}
.vue-accordion ul li:last-child {
  margin-right: 0;
}
.vue-accordion ul li a {
  display: block;
  width: 100%;
  position: relative;
  z-index: 3;
  vertical-align: bottom;
  box-sizing: border-box;
  color: #fff;
  text-decoration: none;
  transition: all 200ms ease;
  height: 100%;
}
.vue-accordion ul li a > .liBox {
  padding: 15px 20px;
  bottom: 0;
  position: absolute;
  height: fit-content;
  box-sizing: border-box;
  /* max-height: 155px; */
}
.vue-accordion ul li a > img {
  top: 280px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.vue-accordion ul li a > .sanjiao {
  top: 280px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%) !important;
  height: 10px;
  width: 42px;
  overflow: hidden;
}
.vue-accordion ul li a > .sanjiao div {
  height: 10px;
  width: 42px;
  position: absolute;
  left: 50%;
  transform: scaleX(2.1) !important;
}
.sanjiao div::before {
  content: " ";
  color: transparent;
  position: absolute;
  bottom: 4.14px;
  display: block;
  height: 20px;
  width: 20px;
  border-top-left-radius: 6px;
  transform: rotate(-135deg) !important;
  background: rgba(0, 0, 0, 0.4);
}
.redHengBox .redHeng {
  width: 40px;
  height: 6px;
  background: #df3a3a;
  border-radius: 3px;
  margin: 0 auto;
  margin-left: 60px;
}
.liBox .redHeng {
  width: 40px;
  height: 6px;
  background: #df3a3a;
  border-radius: 3px;
  margin-bottom: 19px;
}
.vue-accordion ul li a > .redHengBox {
  padding: 15px 20px;
  bottom: 0;
  left: 27%;
  position: absolute;
  height: fit-content;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.vue-accordion ul li a * {
  margin: 0;
  /* width: 100%; */
  position: relative;
  z-index: 5;
  /* overflow: hidden; */
  -webkit-transform: translateX(-20px);
  transform: translateX(-20px);
  -webkit-transition: all 400ms ease;
  transition: all 400ms ease;
  font-family: "Source Han Sans CN Normal";
}

.vue-accordion ul li a h2 {
  text-overflow: clip;
  font-size: 28px;
  font-weight: normal;
  font-family: "Source Han Sans CN Normal";
  text-transform: uppercase;
  margin-bottom: 16px;
  -webkit-transform: translateX(0);
  transform: translateX(0);
}

.vue-accordion ul li a h3 {
  text-overflow: clip;
  font-size: 20px;
  font-weight: normal;
  text-align: center;
  font-family: "Source Han Sans CN Normal";
  text-transform: uppercase;
  margin-bottom: 20px;
  /* padding-top: 208px; */
  -webkit-transform: translateX(0);
  transform: translateX(0);
  white-space: nowrap;
}
.vue-accordion ul li a p {
  width: 100%;
  opacity: 0;
  font-size: 16px;
}

.vue-accordion ul li {
  width: 240px;
}

.vue-accordion ul li.active {
  /* overflow: hidden; */
  width: 500px;
}

.vue-accordion ul li.active a {
  background: rgba(0, 0, 0, 0.4);
}

.vue-accordion ul li.active a * {
  opacity: 1;
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
</style>



// WEBPACK FOOTER //
// src/components/vue-accordion/vue-accordion-partial.vue